import * as React from "react";
import CalendarIcon from "./CalendarIcon";
import ArrowIcon from "./ArrowIcon";
import { StationDefinition } from "../api/api-data-model";
import { format } from "date-fns";
import frLocale from "date-fns/locale/fr";
import { LocationDescriptor } from "history";
import { Redirect } from "react-router-dom";
import AppNavigationState from "../utils/AppNavigationState";
import { WithTranslationLangProps } from "../utils/i18next/with-translation-keys";
import { withTranslation } from "react-i18next";

interface ISearchResultHeaderProps extends WithTranslationLangProps {
  from?: StationDefinition;
  to?: StationDefinition;
  date?: Date;
  showDate?: boolean;
}

interface ISearchResultHeaderState {
  redirect?: LocationDescriptor<AppNavigationState>;
}

class SearchResultHeader extends React.Component<
  ISearchResultHeaderProps,
  ISearchResultHeaderState
> {
  public static defaultProps = {
    showDate: true,
  };

  constructor(props: ISearchResultHeaderProps) {
    super(props);
    this.state = {};
    this.handleEditJourneyClicked = this.handleEditJourneyClicked.bind(this);
  }

  private handleEditJourneyClicked() {
    let redirect = {
      pathname: "/",
      state: {
        searchContext: {
          fromStation: this.props.from,
          toStation: this.props.to,
          searchDate: this.props.date,
        },
      },
    };
    this.setState({ redirect: redirect });
  }

  render() {
    if (this.state.redirect) return <Redirect push to={this.state.redirect} />;
    return (
      <div className="search-header">
        <div className="container-lg">
          <div className="row align-items-center">
            <div className="col-3 d-none d-md-block text-left">
              {this.props.date && this.props.showDate && (
                <>
                  <CalendarIcon width="1.5rem" />
                  <span className="d-none d-lg-inline-block">
                    {this.props.date &&
                      format(this.props.date, "d MMM yyyy - HH:mm", {
                        locale: frLocale,
                      })}
                  </span>
                  <span className="d-lg-none">
                    {this.props.date &&
                      format(this.props.date, "dd/MM/yy - HH:mm", {
                        locale: frLocale,
                      })}
                  </span>
                </>
              )}
            </div>
            <div className="col-12 col-md-6 pb-2 pb-md-0 text-center">
              {this.props.from?.name}
              <ArrowIcon width="1.5rem" />
              {this.props.to?.name}
            </div>
            <div className="col-6 d-block d-md-none text-left">
              {this.props.date && this.props.showDate && (
                <>
                  <CalendarIcon width="1.5rem" />
                  {this.props.date &&
                    format(this.props.date, "d MMM yyyy - HH:mm", {
                      locale: frLocale,
                    })}
                </>
              )}
            </div>
            <div
              className={
                (this.props.date ? "col-6 text-right" : "col-12 text-center") +
                " col-md-3 text-md-right"
              }
            >
              <button
                className="prveo-btn prveo-btn-primary btn-border"
                id="edit-journey-btn"
                onClick={this.handleEditJourneyClicked}
              >
                {this.props.t("edit_my_trip")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(SearchResultHeader);
